<template>
  <div class="search" :style="{ 'background-image': 'url(' + require('../assets/bg.jpg') + ')' }" style="background-size: cover;">
    <div style="height: 120px;"></div>
    <div :style="{ 'background-image': 'url(' + require('../assets/c1.jpg') + ')' }" style="background-size: cover;max-width: 480px; max-height: 100px; width:100vw; height: calc(100vw * 100 / 480); margin: 0 auto;">
    </div>
    <div style="height: 10px;"></div>
    <template v-if="data.searched == false">
      <div style="background-color: #d1dbe5; max-width: 480px; width:100vw; margin: 0 auto;">
        <div style="height: 30px;"></div>
        <div style="display: flex;">
          <div style="font-size: 14px;height: 20px;width: 20%; margin-right: 10px;padding-top: 5px;text-align: right;">姓名</div>
          <div style="width: 60%; height: 20px; font-size: 14px; margin-right: 10px;">
            <input v-model="data.name" type="text" style="width: 100%; height: 24px; margin: 0; padding: 1px 10px; border: 1px #A6B7CB solid; font-size: 13px;" placeholder="请输入姓名" />
          </div>
        </div>
        <div style="height: 20px;"></div>
        <div style="display: flex;">
          <div style="font-size: 14px;height: 20px;width: 20%; margin-right: 10px;padding-top: 5px;text-align: right;">证书编号</div>
          <div style="width: 60%; height: 20px; font-size: 14px; margin-right: 10px;">
            <input v-model="data.certificateNumber" type="text" style="width: 100%; height: 24px; margin: 0; padding: 1px 10px; border: 1px #A6B7CB solid; font-size: 13px;" placeholder="请输入证书编号" />
          </div>
        </div>
        <div style="height: 20px;"></div>
        <div style="display: flex;">
          <div style="font-size: 14px;height: 20px;width: 20%; margin-right: 10px;padding-top: 5px;text-align: right;">身份证号</div>
          <div style="width: 60%; height: 20px; font-size: 14px; margin-right: 10px;">
            <input v-model="data.idCard" type="text" style="width: 100%; height: 24px; margin: 0; padding: 1px 10px; border: 1px #A6B7CB solid; font-size: 13px;" placeholder="请输入身份证号" />
          </div>
        </div>
        <div style="height: 20px;"></div>
        <div style="margin: auto;width: 50%;">
          <button style="width: 100%; height: 30px; font-size: 14px; margin: auto;" @click="search">确认查询</button>
        </div>
        <div style="height: 20px;"></div>
      </div>
    </template>
    <template v-else>
      <template v-if="!data.product">
        <div style="background-color: #d1dbe5; max-width: 480px; width:100vw; margin: 0 auto;">
          <div style="height: 20px;"></div>
          <div style="font-size: 15px; color: red; text-align: center;">
            未查询到相关信息！
          </div>
          <div style="height: 20px;"></div>
          <div style="font-size: 15px; color: red; text-align: center;">
            请重新输入或检查您输入的信息是否正确！
          </div>
          <div style="height: 20px;"></div>
          <div style="margin: auto;width: 50%;">
            <button style="width: 100%; height: 30px; font-size: 14px; margin: auto;" @click="data.searched = false">重新查询</button>
          </div>
          <div style="height: 20px;"></div>
        </div>
      </template>
      <template v-else>
        <div style="background-color: #d1dbe5; max-width: 480px; width:100vw; margin: 0 auto;">
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">姓名：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.name }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">系列名称：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.seriesName }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">性别：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.sex }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">专业名称：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.majorName }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">籍贯：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.nativePlace }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">资格名称：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.qualificationName }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">出生日期：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.birthDate }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">批准日期：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.approveDate }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">发证单位：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.issueUnit }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">发证日期：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.issueDate }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">网址：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.netHost }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">身份证号：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.idCard }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">备注：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.remark }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="display: flex;">
            <div style="font-size: 14px;width: 25%; margin-right: 10px;text-align: right;">证书编号：</div>
            <div style="font-size: 14px;width: calc(75% - 20px); margin-right: 10px;">{{ data.product.certificateNumber }}</div>
          </div>
          <div style="height: 5px;"></div>
          <div style="margin: auto;width: 50%;">
            <button style="width: 100%; height: 30px; font-size: 14px; margin: auto;" @click="data.searched = false">重新查询</button>
          </div>
          <div style="height: 5px;"></div>
        </div>
      </template>
    </template>
    <div style="height: 10px;"></div>
    <div style="text-align: center;font-size: 13px;">
      调解工作人员在线信息查询官方系统<br />
      年检电话：0571-86035606。邮箱：huo_jb@163.com<br />
      中华人民共和国工信部备案许可：浙ICP备2025160170号-1<br />
      版权所有：浙江省投融资协会人民调解委员会<br />
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import api from '../apis/api'
import cache from '../utils/cache'

const data = reactive({
  name: '',
  idCard: '',
  certificateNumber: '',
  searched: false,
  product: null,
})

const search = () => {
  if (!data.name) {
    alert('请填写姓名')
    return
  }
  if (!data.idCard) {
    alert('请填写编号')
    return
  }
  if (!data.certificateNumber) {
    alert('请填写身份证号')
    return
  }
  api.get('/backend/product/selfsearch', {
    params: {
      name: data.name,
      idCard: data.idCard,
      certificateNumber: data.certificateNumber
    }
  }).then(res => {
    data.product = res
    data.searched = true
  })
}
</script>

<style lang="less">
.search {
  background-color: cadetblue;
  width: 100vw;
  height: 100vh;
  min-height: 600px;
}
</style>